var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedinNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
    fill: "#0077B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.65948 7.41135C8.65948 8.1959 8.06893 8.82368 7.12069 8.82368H7.10331C6.19033 8.82368 5.6001 8.1959 5.6001 7.41135C5.6001 6.6102 6.2083 6 7.13861 6C8.06893 6 8.64183 6.6102 8.65948 7.41135ZM8.48063 9.93766V18.1085H5.76117V9.93766H8.48063ZM18.2878 18.1073L18.2879 13.4224C18.2879 10.9127 16.9463 9.7446 15.1568 9.7446C13.713 9.7446 13.0665 10.5377 12.7056 11.094V9.93669H9.98579C10.0216 10.7034 9.98579 18.1075 9.98579 18.1075H12.7056V13.5443C12.7056 13.3001 12.7232 13.0565 12.7951 12.8816C12.9917 12.3938 13.4392 11.8887 14.1905 11.8887C15.1749 11.8887 15.5685 12.6379 15.5685 13.7359V18.1073H18.2878Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinNew);
export default __webpack_public_path__ + "static/media/linkedin-new.c9d1cfe5f4080a1efd4cf65de05295b3.svg";
export { ForwardRef as ReactComponent };